<template>
  <div class="summary-header">
    <h2 class="summary-selection">{{ title }}</h2>

    <div class="summary-actions">
      <button class="button-link" @click="$emit('openModal')">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 21">
          <path
            fill="currentColor"
            d="M22.808 4.90185c.3571.50893.4375 1.08483.2411 1.72768L19.366 18.7635c-.1696.5714-.5111 1.0513-1.0245 1.4397-.5134.3884-1.0603.5826-1.6407.5826H4.33923c-.6875 0-1.35045-.2389-1.98884-.7165-.63839-.4777-1.08259-1.0648-1.33259-1.7612-.214286-.5982-.223215-1.1652-.026786-1.7009 0-.0357.013396-.1562.040176-.3616.02679-.2054.04465-.3705.05357-.4955.00893-.0715-.00446-.1674-.04017-.288-.03572-.1205-.049112-.2076-.04018-.2611.01785-.0983.05357-.192.10714-.2813.05357-.0893.12723-.1942.22098-.3147.09375-.1206.16741-.2255.22098-.3148.20536-.3392.40625-.7477.60268-1.2254s.33036-.8862.40179-1.2254c.02678-.0893.02902-.2233.00669-.4018-.02232-.1786-.02455-.3036-.00669-.375.02678-.0982.10268-.2232.22768-.375s.20089-.2545.22768-.3081c.1875-.3214.375-.73211.5625-1.23211s.2991-.90179.33482-1.20536c.00893-.08035-.00223-.22321-.03348-.42857-.03125-.20536-.02902-.33036.00669-.375.03572-.11607.13393-.25223.29464-.40848.16072-.15625.25893-.2567.29465-.30134.16964-.23214.35937-.60937.56919-1.1317.20983-.52232.33259-.95312.36831-1.29241.00893-.07143-.00447-.18526-.04018-.34151-.03572-.15625-.04464-.27456-.02679-.35491.01786-.07143.05804-.15179.12054-.24108.0625-.08928.14286-.19196.24107-.30803.09821-.11607.17411-.20982.22768-.28125.07143-.10714.14509-.24331.22098-.40848.07589-.16518.14286-.32143.20089-.46875.05804-.14733.12947-.30804.21429-.48215.08482-.174104.17187-.316961.26116-.428568.08929-.111607.20759-.216518.35491-.314732.14732-.098215.30804-.149554.48214-.154018.17411-.004464.38616.020089.63616.073661l-.01339.040178c.33929-.080357.56697-.120536.68304-.120536H19.1651c.6607 0 1.1697.25 1.5268.75.3572.500005.4375 1.080355.2411 1.741075L17.2633 14.8394c-.3214 1.0625-.6406 1.7477-.9576 2.0558-.3169.308-.8906.462-1.7209.462H2.94637c-.24107 0-.41071.067-.50893.2009-.09821.1429-.10268.3348-.01339.5759.21429.625.85714.9375 1.92857.9375H16.7142c.259 0 .509-.0692.75-.2076.2411-.1384.3974-.3237.4688-.5558l4.0178-13.21875c.0625-.19642.0849-.45089.067-.76339.3393.13393.6027.32589.7902.57589zm-14.25002.02679c-.03572.11607-.02679.21652.02678.30134.05358.08482.14286.12723.26786.12723h8.14288c.1161 0 .2299-.04241.3415-.12723.1116-.08482.1853-.18527.221-.30134l.2812-.85714c.0357-.11607.0268-.21652-.0268-.30134-.0535-.08482-.1428-.12723-.2678-.12723H9.40173c-.11607 0-.22991.04241-.34152.12723-.11161.08482-.18527.18527-.22098.30134l-.28125.85714zM7.44637 8.35721c-.03571.11607-.02678.21652.02679.30134.05357.08482.14285.12723.26785.12723h8.14289c.116 0 .2299-.04241.3415-.12723.1116-.08482.1853-.18527.221-.30134l.2812-.85714c.0357-.11607.0268-.21652-.0268-.30134-.0535-.08482-.1428-.12723-.2678-.12723H8.29012c-.11607 0-.22991.04241-.34152.12723-.1116.08482-.18526.18527-.22098.30134l-.28125.85714z"
          />
        </svg>
        Methodology
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Summary",
    props: {
      title: String,
    },
  };
</script>

<style scoped>
  .summary-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--spacing-unit-tiny) var(--spacing-unit-tiny);
    margin-bottom: 16px;
  }

  .summary-selection {
    margin: 0;
    font-size: 18px;
    line-height: 1.1;
    font-weight: 600;
  }

  .selection-wrap {
    flex: 0 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }

  .button-link {
    color: var(--color-blue-400);
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    font-weight: 700;
    border: 0;
    background: transparent;
    cursor: pointer;
  }
  .button-link svg {
    margin-right: var(--spacing-unit-tiny);
    width: 24px;
  }
  .button-link:hover {
    text-decoration: none;
  }
</style>
